<div *ngIf="aberta"
  class="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[80] px-3 sm:px-4">
  <div class="w-full max-w-md rounded-md bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-2xl p-5">
    <div class="flex items-start gap-3">
      <div class="h-10 w-10 rounded-full bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300 flex items-center justify-center shrink-0">
        <lucide-icon [img]="alertTriangleIcon" class="w-5 h-5"></lucide-icon>
      </div>
      <div class="min-w-0 flex-1">
        <h3 class="text-base font-semibold text-gray-900 dark:text-gray-100">{{ titulo }}</h3>
        <div class="text-sm leading-relaxed text-gray-600 dark:text-gray-300 mt-2">
          <ng-content></ng-content>
        </div>
      </div>
    </div>

    <div class="mt-5 flex w-full flex-row gap-3 sm:justify-end">
      <button type="button" (click)="confirmar.emit()"
        class="flex-1 sm:flex-none rounded-md bg-red-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-red-700 inline-flex items-center justify-center gap-2">
        <lucide-icon *ngIf="carregando" [img]="loader2Icon" class="w-4 h-4 animate-spin"></lucide-icon>
        {{ labelConfirmar }}
      </button>
      <button type="button" (click)="cancelar.emit()"
        class="flex-1 sm:flex-none rounded-md border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800">
        {{ labelCancelar }}
      </button>
    </div>
  </div>
</div>
